import PropTypes from "prop-types";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDButton from "components/MDButton";

const JobGroupCard = ({
  groupId,
  groupName,
  competencyCount,
  expanded,
  canEdit,
  onToggle,
  onAddCompetency,
  children,
}) => {
  return (
    <Accordion expanded={expanded} onChange={() => onToggle(groupId)} sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
          <Typography fontWeight={700}>{groupName}</Typography>

          <Typography color="text.secondary">{competencyCount} Competencies</Typography>
        </Stack>
      </AccordionSummary>

      <AccordionDetails>
        {children}

        {canEdit && (
          <MDButton color="primary" variant="contained" sx={{ mt: 2 }} onClick={onAddCompetency}>
            Add Competency
          </MDButton>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

JobGroupCard.propTypes = {
  groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  groupName: PropTypes.string.isRequired,
  competencyCount: PropTypes.number.isRequired,
  expanded: PropTypes.bool,
  canEdit: PropTypes.bool,
  onToggle: PropTypes.func,
  onAddCompetency: PropTypes.func,
  children: PropTypes.node,
};

export default JobGroupCard;
